import React, { useState, useEffect, useMemo } from 'react';
import { LuFileText } from "react-icons/lu";
import { FiEdit,FiEye,FiUser,FiClock } from "react-icons/fi";
import DraftList from './draftList';
import { useDispatch, useSelector } from "react-redux";
import { getViewdraftsFilter } from "../../../../../../store/actions/cms/scheduler";
import { clearData } from "../../../../../../store/slices/scheduler";
import DOMPurify from 'dompurify';
import { OverlayTrigger } from "react-bootstrap";
import { showTooltipMsg } from '../../../../../utils';
import HtmlDiffViewer from '../../../../utils/htmlDiff';

const DraftContentComparison = (props) => {
  const dispatch = useDispatch();
  const [showDraftsList, setShowDraftsList] = useState(false);
  const [showComparisonView, setShowComparisonView] = useState(false);
  const [selectedDraft, setSelectedDraft] = useState(null);
  const [legends, setLegends] = useState({ added: 0, removed: 0, modified: 0 });
  const { viewDraftsData,viewDrafsLoading } = useSelector((state) => {
    return (state?.contentSchedularReducer);
  });

  const oldHtml = `<p dir="ltr" style="text-align: justify;">In Maharashtra state-level seats, there will be two categories which are Home University and other than home university. Those applicants who cleared the MA</p>`;
  const newHtml = `<p dir="ltr" style="text-align: justify;">In Maharashtra state-level seats, there will be <b>two major categories</b>: Home University and Other than Home University. Applicants who cleared the MA entrance exam are eligible.</p>`;
  // API call for draft list on the basis of content_type
  useEffect(() => {
    if (showDraftsList) {
      dispatch(getViewdraftsFilter(showDraftsList))
    }
  }, [showDraftsList])

  const formatDateTime = (dateTime) => {
    const formatted = new Date(dateTime).toLocaleString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  
    return formatted.replace(/\b(am|pm)\b/g, (match) => match.toUpperCase());
  };
  

  const handleViewDraft = (draft) => {
    setSelectedDraft(draft);
    setShowDraftsList(false);
    setShowComparisonView(true);
  };

  const closeDraftsList = () => {
    setShowDraftsList(false);
    // clear redux state
    dispatch(clearData());
  };

  const closeComparisonView = () => {
    setShowComparisonView(false);
    setSelectedDraft(null);
    // clear redux state
    dispatch(clearData());
  };

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1050
    },
    fullScreenOverlay: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      width: '90%',
      backgroundColor: 'white',
      zIndex: 1050,
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Inter',
    },
    splitView: {
      display: 'flex',
      flex: 1,
      overflow: 'hidden'
    },
    leftPanel: {
      width: '50%',
      borderRight: '1px solid #e6e6e6',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      color: '#474747',
      padding: '0px 20px 0px 50px',
    },
    rightPanel: {
      width: '50%',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      color: '#474747',
      padding: '0px 50px 0px 20px',
    },
    scrollableContent: {
      flex: 1,
      overflowY: 'auto',
      padding: '2rem 1rem',
      scrollbarWidth: "thin",
    },
  };

  const showLoader=()=>{
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status" />
      </div>
    )
  }
  return (
    <>
      {/* Bootstrap CSS CDN */}
      {/* <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      /> */}

      <div className="draft_comparision">
        {/* Demo button to show drafts list */}
        {/* {!showDraftsList && !showComparisonView && ( */}
        <DraftList setShowDraftsList={setShowDraftsList} currentPage={props.currentPage} setCurrentPage={props.setCurrentPage} setDraftLength={props.setDraftLength}/>
        {/* )} */}

        {/* Drafts List Popup */}
        {showDraftsList && (
          <div style={styles.overlay}>
            <div className="modal-dialog modal-xl d-flex align-items-center" style={{width:'844px'}}>
              <div className="modal-content view_modal" style={{width:'100%'}}>
                <div className="modal-header bg-light view_head">
                  <div className="d-flex align-items-center view_head_conatiner">
                    <div className='view_svg_conatiner'>
                      <LuFileText className="me-2 text-primary view_svg" size={20} />
                    </div>
                    <div>
                      <p className='view_type'>TYPE</p>
                      <small className="text-muted view_subhead">{viewDraftsData?.published_draft_data?.content_type?.charAt(0).toUpperCase() + viewDraftsData?.published_draft_data?.content_type?.slice(1)}</small>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn-close view_close"
                    onClick={closeDraftsList}
                  ></button>
                </div>

                <div className="modal-body p-4 view_table-container">
                  <h5 className="modal-title fw-semibold mb-0 view_heading">
                    {viewDraftsData?.published_draft_data?.content_title? viewDraftsData?.published_draft_data?.content_title.charAt(0).toUpperCase() + viewDraftsData?.published_draft_data?.content_title?.slice(1):showLoader()} 
                  </h5>
                  <div className="table-responsive view_table">
                    <table className="table table-hover view_table_hover">
                      <thead className="table-light view_table_head">
                        <tr>
                          <th className="fw-semibold view_table_heading">Version</th>
                          <th className="fw-semibold view_table_heading">Date and Time</th>
                          <th className="fw-semibold view_table_heading">Drafting Methods</th>
                          <th className="fw-semibold view_table_heading">Author</th>
                          <th className="fw-semibold view_table_heading">Action</th>
                        </tr>
                      </thead>
                      <tbody>

                        {viewDraftsData ? 
                          viewDraftsData?.unpublished_drafts?.map((draft, index) => {
                            const lastIndex = viewDraftsData?.unpublished_drafts?.length - 1;
                            return (
                            <tr key={draft.id} className='view_table_row'>
                            <td className="fw-medium view_table_text">{draft?.draft_version}</td>
                            <td className="text-muted view_table_text">
                                <div className="d-flex align-items-center">
                                  {formatDateTime(draft?.updated_at)}
                                </div>
                              </td>
                              <td>
                                <span className={`badge ${draft?.is_auto_saved
                                    ? 'auto_save'
                                    : 'manual_save'
                                  }`}>
                                  {draft?.is_auto_saved ? 'Auto' : 'Manual'}
                                </span>
                              </td>
                              <td className="text-muted view_table_text">
                                {draft?.author_name}
                              </td>
                              <td>
                                <div className='btn_container'>
                                <OverlayTrigger
                                    placement="bottom"
                                    trigger={['hover', 'focus']}
                                    overlay={showTooltipMsg('View Draft Version')}
                                >
                                  <button
                                    onClick={() => handleViewDraft(draft)}
                                    className="view_buttton"
                                  >
                                    <FiEye className="me-1" size={20} />
                                  </button>
                                </OverlayTrigger>
                                {lastIndex == index && (
                                  <OverlayTrigger
                                    placement="bottom"
                                    trigger={['hover', 'focus']}
                                    overlay={showTooltipMsg('Edit Version')}
                                  >
                                      <a href={viewDraftsData?.draft_edit_url} target='_blank'><FiEdit size={18} className='edit_button' /></a>
                                  </OverlayTrigger>
                                )}
                                </div>
                              </td>
                            </tr>
                            );
                          }):
                          viewDrafsLoading && (
                            <tr>
                              <td colSpan="5">
                                {showLoader()}
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>

                  <div className="text-center mt-3">
                    <small className="text-muted view_drafts" style={{fontSize:'12px'}}>
                      Showing {viewDraftsData?.unpublished_drafts?.length} draft(s)
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Full Screen Comparison View */}
        {showComparisonView && selectedDraft && (
          <div style={styles.fullScreenOverlay} className='add_transition'>
            {/* Header */}
            <div className="" style={{textAlign:'end',margin:'10px 20px -10px 0px',zIndex:'11'}}>
              <button
                type="button"
                className="btn-close comparision_close"
                onClick={closeComparisonView}
              ></button>
            </div>

            {/* Content */}
            <div style={styles.splitView}>
              {/* Published Version - Left */}
              <div style={styles.leftPanel}>
                <div className="p-3 border-bottom heading">
                  <h5 className="fw-semibold mb-1">Latest Published Version</h5>
                </div>
                <div className="p-3 d-flex align-items-center text-muted gap-3" style={{ height: '52px', borderBottom: '1px solid rgba(180, 182, 239, 0.2)', paddingBottom: '3px' }}>
                  <div><FiUser className='logo' /> <small>{viewDraftsData?.published_draft_data?.author_name}</small></div>
                  <div><FiClock className="logo" /> <small>{formatDateTime(viewDraftsData?.published_draft_data?.created_at)}</small></div>
                </div>
                <div style={styles.scrollableContent} className='scrollableContent'>
                  <div className="mb-4 d-flex">
                    <span className="fw-semibold me-1" style={{ color: '#48569a' }}>Title:</span>
                    <span style={{ lineHeight: '1.6' }}> {viewDraftsData?.published_draft_data?.content_title} </span>
                  </div>

                  <div className="mb-4 d-flex">
                    <span className="fw-semibold me-1" style={{ color: '#48569a' }}>Strap: </span>
                    <span style={{ lineHeight: '1.6' }}>
                      {viewDraftsData?.published_draft_data?.content_sub_heading}
                    </span>
                  </div>

                  <div className="question_card">
                    <h6 className="question_card_title" style={{textTransform: 'capitalize'}}>Question Cards ({viewDraftsData?.published_draft_data?.content_type}):</h6>
                    <div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(viewDraftsData?.published_draft_data?.content_story) }} />
                  </div>
                </div>
              </div>

              {/* Draft Version - Right */}
              <div style={styles.rightPanel}>
                <div className="p-3 border-bottom heading">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <h5 className="fw-semibold mb-0">Draft Version - {selectedDraft?.draft_version}</h5>
                    <select
                      value={selectedDraft?.id}
                      onChange={(e) => {
                        const newDraft = viewDraftsData?.unpublished_drafts?.find(d => d.id === parseInt(e.target.value));
                        if (newDraft){ 
                          setLegends({ added: 0, removed: 0, modified: 0 })
                          setSelectedDraft(newDraft);
                        }
                      }}
                      className="form-select form-select-sm"
                      style={{ width: 'auto',borderRadius:'8px',paddingLeft:'12px'}}
                    >
                      {viewDraftsData?.unpublished_drafts?.map((draft) => (
                        <option key={draft?.id} value={draft?.id}>
                          Draft Version - {draft?.draft_version}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <div className="p-3 d-flex align-items-center text-muted gap-2 justify-content-between" style={{ height: '52px', borderBottom: '1px solid rgba(180, 182, 239, 0.2)' }}>
                    <div>
                      <div><FiUser className='logo' /> <small className='me-3'>{selectedDraft?.author_name}</small>
                        <FiClock className='logo' /> <small>{formatDateTime(selectedDraft?.created_at)}</small></div>
                    </div>
                    {/* Changes Legend */}
                  {/* need to show legends here */}
                  <div className="d-flex gap-2">
                    <span className="legend text-success tags tags_sucess">Added: {legends.added}</span>
                    <span className="legend text-primary tags tags_primary">Modified: {legends.modified}</span>
                    <span className="legend text-danger tags tags_danger">Removed: {legends.removed}</span>
                  </div>
                  </div>

                </div>

                <div style={styles.scrollableContent}>
                  <div className="mb-4 d-flex">
                    <span className="fw-semibold me-1" style={{ color: '#48569a' }} >Title: </span>
                    <div style={{ display: "inline-block", maxWidth: "100%", wordBreak: "break-word" }}>
                      <HtmlDiffViewer
                        oldHtml={viewDraftsData?.published_draft_data?.content_title || ""}
                        newHtml={selectedDraft?.content_title || ""}
                        setLegends={setLegends}
                      />
                    </div>
                  </div>

                  <div className="mb-4 d-flex">
                      <span className="fw-semibold me-1" style={{ color: '#48569a' }}>Strap: </span>
                      <div style={{ display: "inline-block", maxWidth: "100%", wordBreak: "break-word" }}>
                        <HtmlDiffViewer
                          oldHtml={viewDraftsData?.published_draft_data?.content_sub_heading || ""}
                          newHtml={selectedDraft?.content_sub_heading || ""}
                          setLegends={setLegends}
                          mergeLegends
                        />
                      </div>
                  </div>

                  <div className="question_card">
                    <h6 className="question_card_title" style={{textTransform: 'capitalize'}}>Question Cards ({selectedDraft?.content_type}):</h6>
                    <div>
                      <HtmlDiffViewer oldHtml={viewDraftsData?.published_draft_data?.content_story} newHtml={selectedDraft?.content_story} setLegends={setLegends} mergeLegends/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DraftContentComparison;